import { AuthenticationManager } from '@frontend/authentication-v2';
import { BpostBarcodeClient, BpostShippingLabelClient } from '@frontend/bpost/api';
import { Barcode } from '@frontend/bpost/types';
import { EntityType } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { ErrorHandler } from '@frontend/error-handler';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import OverviewHeader from '../../header/overview-header';
import { useLabels } from './labels.controller';
import { PreviewHTML } from './preview-html/preview-html';
import { PreviewPDF } from './preview-pdf/preview-pdf.component';
import { PrintModal } from './print-modal/print-modal';

export const Labels = () => {
    const viewProps = useLabels();

    return (
        <div className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>
            <OverviewHeader
                title={CommonMessage.OBJECTS.LABEL.PLURAL}
                create={{
                    onCreate: () =>
                        AuthenticationManager.getInstance()
                            .getTokenWhenReady()
                            .then(async (token) => {
                                if (!token) return;
                                await BpostBarcodeClient.generateBarcode(viewProps.currentAccount, {
                                    sender_spot_id: viewProps.defaultSpotId!,
                                    receiver_spot_id: viewProps.defaultSpotId!,
                                    receiver_user_id: token.entity_id,
                                    retour: true
                                });
                            }),
                    entity: EntityType.BARCODE,
                    hide: !viewProps.defaultSpotId,
                    overwriteCreateLabel: CommonMessage.BUTTONS.GENERATE(CommonMessage.OBJECTS.LABEL.DEFAULT)
                }}
            />
            <ReactiveObjectList<Barcode>
                dispatch={viewProps.dispatch}
                fetch={(arg) =>
                    BpostBarcodeClient.fetchBarcodes({
                        ...arg,
                        account_id: viewProps.currentAccount
                    })
                }
                eventListener={EntityType.BARCODE}
                id={viewProps.listId}
                useStaticListId
                activeFilter={{
                    searchKeys: ['code']
                }}
                columns={{
                    columns: ['code', 'creation_timestamp'],
                    customActionButtons: [
                        {
                            label: (
                                <FormattedMessage
                                    id='labels.previewHtml'
                                    defaultMessage='Preview HTML'
                                />
                            ),
                            onClick: (obj) =>
                                BpostShippingLabelClient.previewShippingLabelHTML(obj.account_id, obj.id)
                                    .then((value) => {
                                        viewProps.openModal('preview-html', () => <PreviewHTML content={value} />);
                                    })
                                    .catch((err) => ErrorHandler.handleError({ error: err }))
                        },
                        {
                            label: (
                                <FormattedMessage
                                    id='labels.previewPdf'
                                    defaultMessage='Preview PDF'
                                />
                            ),
                            onClick: (obj) => viewProps.openModal('preview-pdf', () => <PreviewPDF barcode={obj} />)
                        },
                        {
                            label: (
                                <FormattedMessage
                                    id='labels.printLabel'
                                    defaultMessage='Print label'
                                />
                            ),
                            onClick: (obj) =>
                                viewProps.openModal('print-label-modal', () => (
                                    <PrintModal
                                        id='print-label-modal'
                                        onCancel={() => viewProps.closeModal('print-label-modal')}
                                        dispatch={viewProps.dispatch}
                                        barcode={obj}
                                    />
                                ))
                        }
                    ]
                }}
                type={EntityType.BARCODE}
            />
        </div>
    );
};
